import React, { useState } from 'react'

const CloseIcon = ({ onClick = () => {} }) => {
  const [hovered, setHovered] = useState(false)
  return (
    <svg
      width='40'
      height='40'
      viewBox='0 0 24 24'
      fill='none'
      className='close_icon_svg'
      xmlns='http://www.w3.org/2000/svg'
      onMouseOver={() => setHovered(true)}
      onMouseOut={() => setHovered(false)}
      onClick={onClick}
      style={{ transition: 'all 0.3s ease-in-out', cursor: 'pointer' }}>
      <path
        d='M3.35288 8.95043C4.00437 6.17301 6.17301 4.00437 8.95043 3.35288C10.9563 2.88237 13.0437 2.88237 15.0496 3.35288C17.827 4.00437 19.9956 6.17301 20.6471 8.95044C21.1176 10.9563 21.1176 13.0437 20.6471 15.0496C19.9956 17.827 17.827 19.9956 15.0496 20.6471C13.0437 21.1176 10.9563 21.1176 8.95044 20.6471C6.17301 19.9956 4.00437 17.827 3.35288 15.0496C2.88237 13.0437 2.88237 10.9563 3.35288 8.95043Z'
        stroke={hovered ? 'black' : '#656676'}
        strokeWidth='1.5'
      />
      <path
        d='M13.7678 10.2322L10.2322 13.7678M13.7678 13.7678L10.2322 10.2322'
        stroke={hovered ? 'black' : '#656676'}
        strokeWidth='1.5'
        strokeLinecap='round'
      />
    </svg>
  )
}

export default CloseIcon
